import { GetStaticPropsResult } from 'next';

import { getBlogPostsTaggedWithAnySpecies } from '../../src/api/contentful/blog/getBlogPostsTaggedWithAnySpecies';
import { getRutilusGraphqlClient } from '../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../src/api/graphql/queryRutilusStatic';
import { AppLogic } from '../../src/components/AppLogic/AppLogic';
import { buildStateDataSpecies } from '../../src/components/FindUSSpecies/helpers/buildStateDataSpecies';
import { GlobalLayout } from '../../src/components/Layouts/GlobalLayout';
import { DEFAULT_POPULAR_SPECIES } from '../../src/components/PopularSpeciesNearYou/constants';
import { DISCOVER_PAGES_NAV_LINKS } from '../../src/constants/constants';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../src/constants/next';
import {
  SEO_DEFAULT_FAMILY,
  SEO_SPECIES_FAMILIES,
} from '../../src/constants/species/seoSpeciesFamilies';
import TOP_SIX_SPECIES_BY_STATE from '../../src/constants/species/top_6_species_by_us_states_24042024.json';
import { reportMykissError } from '../../src/helpers/errorHandling';
import { getEdgesFromConnection } from '../../src/helpers/graphql';
import { GetSpeciesFromList, GetSpeciesFromListVariables } from '../../src/interfaces/graphql';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { getSpeciesFromList } from '../../src/queries/rutilus/Species';
import { DiscoverSpecies, IDiscoverProps } from '../../src/views/Discover/DiscoverSpecies';

export async function getStaticProps(): Promise<
  GetStaticPropsResult<IPageMetadata & IDiscoverProps>
> {
  try {
    const client = getRutilusGraphqlClient({ serverMode: 'static' });
    const { response } = await queryRutilusStatic<GetSpeciesFromList, GetSpeciesFromListVariables>(
      client,
      {
        query: getSpeciesFromList,
        variables: {
          externalIds: DEFAULT_POPULAR_SPECIES,
        },
      },
    );
    const topSpeciesEdgeList = response ? getEdgesFromConnection(response.data.species) : [];
    const stateSpeciesData = buildStateDataSpecies(TOP_SIX_SPECIES_BY_STATE);

    const { items: blogPostItems } = await getBlogPostsTaggedWithAnySpecies(3);

    return {
      props: {
        _page: 'discover_species',
        _pageTitle: 'Discover Species',
        defaultTopSpeciesEdgeList: topSpeciesEdgeList,
        seoSpeciesFamilies: SEO_SPECIES_FAMILIES,
        seoSpeciesDefultFamily: SEO_DEFAULT_FAMILY,
        stateSpeciesData,
        blogPostItems,
      },
      revalidate: REVALIDATE.DAILY,
    };
  } catch (error) {
    reportMykissError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

DiscoverSpecies.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout siteSubNavigationLinks={DISCOVER_PAGES_NAV_LINKS}>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default DiscoverSpecies;
